import { render, staticRenderFns } from "./AssignCourseId.vue?vue&type=template&id=6c052f34"
import script from "./AssignCourseId.vue?vue&type=script&lang=js"
export * from "./AssignCourseId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports